import { jsx } from 'react/jsx-runtime';
import { createContext, useMemo, useContext } from 'react';

const PM2DisplayContext = createContext({
  inGrid: false,
  inLibrary: false,
  inLightbox: false,
  isEmbedded: false
});
function PM2DisplayProvider(props) {
  const parentStore = usePM2DisplayContext();
  const store = useMemo(
    () => ({
      inGrid: props.inGrid ?? parentStore.inGrid,
      inLibrary: props.inLibrary ?? parentStore.inLibrary,
      inLightbox: props.inLightbox ?? parentStore.inLightbox,
      isEmbedded: props.isEmbedded ?? parentStore.isEmbedded
    }),
    [
      parentStore.inGrid,
      parentStore.inLibrary,
      parentStore.inLightbox,
      parentStore.isEmbedded,
      props.inGrid,
      props.inLibrary,
      props.inLightbox,
      props.isEmbedded
    ]
  );
  return /* @__PURE__ */ jsx(PM2DisplayContext.Provider, { value: store, children: props.children });
}
function usePM2DisplayContext() {
  return useContext(PM2DisplayContext);
}

export { PM2DisplayContext, PM2DisplayProvider, usePM2DisplayContext };
//# sourceMappingURL=context.display-mode.js.map
